module.exports = __webpack_public_path__ + "img/550a.377521bc.png";